import React, { useState, useEffect } from 'react'
import { useGlobal } from 'reactn'
import styles from './LayerControl.module.scss'
import Heading from '../../atoms/heading/Heading'
import LayerSelectorList from '../layerSelector/LayerSelectorList'
import getLayerColour from '../../../helpers/getLayerColour'

const LayerControl = (props) => {
  const { data, selectedState } = props
  const [masterData, setMasterData] = useState(undefined);
  // eslint-disable-next-line
  const [showData, setShowData] = useGlobal('showData')
  const [showDataLookup, setShowDataLookup] = useGlobal('showDataLookup')
  const [, setBuildCSV] = useGlobal("buildCSV");

  // master data from data repo
  useEffect(() => {
    if (masterData === undefined) {
        const loadMasterData = async () => {
            fetch('https://flowminder.github.io/school-optimisation-resources-nigeria/summary/stateDataMaster.json')
                .then(response => response.json())
                .then((jsonData) => {            
                    setMasterData(jsonData)
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        loadMasterData()
    }
}, [masterData, setMasterData])

  function handleChange( event, type ) {
    setShowData(masterData)

    const dataLookup = [...showDataLookup]
    if(type === 'range'){ 
      setBuildCSV([])
      //const rangeLow = event.values[0]
      const rangeHigh = event.values[0]
      // find record in dataLookup
      const result = dataLookup.find(function( obj ) { return obj.id === event.name; })
      if(result){
        const resultPos = dataLookup.indexOf(result);
        result.minRange = 0
        result.maxRange = rangeHigh
        dataLookup[resultPos] = result
      }
      
      // update hi low range in record
    } else if(type === 'opacity'){
      const opacity = parseFloat(event.values)
      // find record in dataLookup
      const result = dataLookup.find(function( obj ) { return obj.id === event.name; })
      if(result){
        const resultPos = dataLookup.indexOf(result);
        result.opacity = opacity
        dataLookup[resultPos] = result
      }
    } 
    
    else {
      if( event.target ) {
        const dataID = event.target.getAttribute('data-id')
        const dataType = event.target.getAttribute('data-type')
        const isChecked = (event.target.value === 'checked') ? false : true
        const inList = ((dataLookup.filter(layer => layer.id === dataID)).length === 0) ? false : true
        if(isChecked && !inList) {
          if(dataID === 'PrimarySchoolsProposed'){
            setBuildCSV([])
          }
          // Get file info from master data
          let layerInfo
          let layerColour
          if (Object.keys(masterData).indexOf(selectedState.toLowerCase()) !== -1) {
            const fileNode = masterData[selectedState.toLowerCase()]
            const reports = fileNode.reports
            const result = reports.find(function( obj ) { return obj.type === dataType; })
            layerInfo = result.layers.find(function( obj ) { return obj.Name === dataID; })
            if (layerInfo) {
              layerColour = getLayerColour(layerInfo.position)
              // Add to array
              dataLookup.push(
                {
                  "state" : selectedState, 
                  "id" : dataID, 
                  "url" : `${layerInfo.URL}`, 
                  "layerColour" : layerColour, 
                  "minRange" :  1, 
                  "maxRange" : layerInfo.count,
                  "opacity" : 0.5
                }
              )
            }
          }
        } else if (!isChecked && inList) {
          //remove from array
          dataLookup.splice(dataLookup.findIndex(item => item.id === dataID), 1)
        }
      }
    }
    setShowDataLookup(dataLookup)
  }

  const createLayerLists = () => {
    const builtLists = data.map((item, i) => {
        return (
            <div className="styles.listInner" key={i}>
                <Heading level={5} type="5" noMargin={true}>{item.type}</Heading>
                <LayerSelectorList data={item.layers} dataType={item.type} listChange={handleChange} selectedState={selectedState} />
            </div>
        )
    })

    return builtLists
  }

  return (
    <div className={styles.layersOuter}>
      <span className={styles.controlTitle}>School Data</span>
      {/* <span className={styles.stateTitle}>Selected State: <span className={styles.stateName}>{selectedState}</span></span>  */}
      <div className={styles.listOuter}>
        {createLayerLists()}
      </div>
    </div>)
}

export default LayerControl
